import React, { useEffect, useState } from 'react';
import { io } from "socket.io-client";
import Sales from './Sales';
import Reports from '../Reports/Reports';
import HappiLanding from '../../components/HappiLanding';



const socket = io("https://mis-api.happimobiles.com", { withCredentials: true, });



const Dashboard = () => {
  const [data, setData] = useState("");
  const [socketStatus,setSocketStatus]=useState("");
  console.log("data",data)
  const [uuid,setUUID]=useState('');
  const [qrCode,setQRCode]=useState('');
  console.log("qrCode",qrCode)
 

  useEffect(() => {
    let localUid=localStorage.getItem('uuid');
    socket.on("connect", () => {
      setSocketStatus("Connected")
      console.log(socket.id, "connetcted");
    });
    socket.on('filter', (data) => {
      console.log(  data)
      window.scrollTo({
        top:0,
        behavior: 'smooth' // Optional: makes the scroll smooth
      });
      if(JSON.parse(localUid) == data?.uuid){
        setData(data)
      }
    })
    socket.on("error", (error) => {
      console.log("erorrr")
      setSocketStatus("error")
      // console.log(socket.id,"dissss"); // undefined
    });
    socket.on("disconnect", () => {
      setSocketStatus("Disconnected")
      console.log(socket.id, "dissss"); // undefined
    });
    // setCurrentUrl(window.location.href)
  

    setSocketStatus("socket run")
    return () => {
      socket.off("message");
    };

  }, []);

  


  return (
   <>
   {
    data?.filtername=="Dashboard"?<Sales data={data}/>:data?.filtername=="Reports"?<Reports data={data}/>:<HappiLanding/>
   }
   {/* {true&&<Reports data={data}/>} */}
   {/* {true&&<Sales data={data}/>} */}
   

   </>
  );
};

export default Dashboard;
